// components/EtatModal.js
import React, { useEffect, useState } from 'react';
import { Modal, Select, Button, Form, message } from 'antd';

const { Option } = Select;

const EtatModal = ({ isOpen, onClose, vente, onEtatChange }) => {
  const [etat, setEtat] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (vente) {
      setEtat(vente.etat || '');
    }
  }, [vente]);

  const handleSubmit = async () => {
    if (!etat) {
      message.warning("Veuillez sélectionner un état");
      return;
    }
  
    setLoading(true);
    try {
      await onEtatChange(vente.id, {etat:etat}); // ✅ send as object
      message.success("État mis à jour avec succès");
      onClose();
    } catch (error) {
      message.error("Erreur lors de la mise à jour de l'état");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <Modal
      title="Modifier l'état de la vente"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item
          label="État"
          required
          validateStatus={!etat ? 'error' : ''}
          help={!etat ? 'Veuillez sélectionner un état' : ''}
        >
          <Select
            placeholder="Sélectionner l'état"
            value={etat}
            onChange={(value) => setEtat(value)} // ✅ Correct for AntD Select
          >
            <Option value="enattente">En attente</Option>
            <Option value="paye">Payé</Option>
            <Option value="annule">Annulé</Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button style={{ marginRight: 8 }} onClick={onClose}>
            Annuler
          </Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            Sauvegarder
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EtatModal;
